"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedToolbarPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BasicButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton");
const BasicButtonDelete_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton/BasicButtonDelete");
const CopyButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/CopyButton");
const Input_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Input");
const BasicTooltip_1 = require("@jsonjoy.com/ui/lib/4-card/BasicTooltip");
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const EditorContextPopup_1 = require("../../chrome/EditorContextPopup");
const EmbedElement_1 = require("../../components/blocks/EmbedElement");
const context_1 = require("./context");
const inputRowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '10px',
});
const actionRowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'space-between',
    gap: '8px',
});
const actionButtonsClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    gap: '6px',
});
const preventMouseDown = (event) => {
    event.preventDefault();
};
const stopMouseDownPropagation = (event) => {
    event.stopPropagation();
};
const EmbedToolbarPopup = () => {
    const state = (0, context_1.useEmbedButton)();
    const open = state.open.use();
    const draftUrl = state.draftUrl.use();
    const draftCaption = state.draftCaption.use();
    const editingPath = state.editingPath.use();
    const normalizedDraft = state.normalizedDraft.use();
    const [previewUrl, setPreviewUrl] = React.useState('');
    React.useEffect(() => {
        if (!open || !normalizedDraft) {
            setPreviewUrl('');
            return;
        }
        const timer = window.setTimeout(() => setPreviewUrl(normalizedDraft), 250);
        return () => window.clearTimeout(timer);
    }, [normalizedDraft, open]);
    const title = editingPath ? 'Edit embed' : 'Add embed';
    const subtitle = editingPath
        ? 'Update the embed link or caption.'
        : 'Paste a link to a video, audio, tweet, or anything else.';
    const actionRow = !!normalizedDraft && (React.createElement("div", { className: actionRowClass, onMouseDown: stopMouseDownPropagation },
        React.createElement("div", { className: actionButtonsClass },
            React.createElement(CopyButton_1.CopyButton, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, onCopy: () => normalizedDraft, tooltip: { nowrap: true, renderTooltip: () => 'Copy URL' } }),
            React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, renderTooltip: () => 'Open source' },
                React.createElement(BasicButton_1.BasicButton, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, to: normalizedDraft },
                    React.createElement(Iconista_1.Iconista, { set: 'lucide', icon: 'external-link', width: 16, height: 16 }))),
            !!editingPath && (React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, renderTooltip: () => 'Remove embed' },
                React.createElement(BasicButtonDelete_1.BasicButtonDelete, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, onConfirm: state.remove }))))));
    const preview = previewUrl ? (React.createElement(EmbedElement_1.EmbedPreview, { url: previewUrl, caption: draftCaption.trim() || undefined, compact: true, width: 400 })) : null;
    return (React.createElement(EditorContextPopup_1.EditorContextPopup, { title: title, subtitle: subtitle, headerRight: actionRow || undefined, minWidth: Math.max(Math.min(500, window.innerWidth * 0.55), 360), applyLabel: editingPath ? 'Update' : 'Insert', applyDisabled: !normalizedDraft, onCancel: state.close, onApply: state.apply },
        React.createElement("div", { className: inputRowClass },
            React.createElement(Input_1.Input, { type: "text", label: "Embed URL", value: draftUrl, placeholder: "https://www.youtube.com/watch?v=...", focus: true, select: open, onChange: state.setDraftUrl, onEnter: (event) => {
                    event.preventDefault();
                    state.apply();
                }, onEsc: (event) => {
                    event.preventDefault();
                    state.close();
                } }),
            React.createElement(Input_1.Input, { type: "text", label: "Caption", value: draftCaption, placeholder: "Optional caption", onChange: state.setDraftCaption, onEnter: (event) => {
                    event.preventDefault();
                    state.apply();
                }, onEsc: (event) => {
                    event.preventDefault();
                    state.close();
                } }),
            preview)));
};
exports.EmbedToolbarPopup = EmbedToolbarPopup;
